// extracted by mini-css-extract-plugin
module.exports = {"root":"NavSearchButton_root__uBhPF","searchIcon":"NavSearchButton_searchIcon__ArzQx"};